import { motion } from "framer-motion";
import ListaPerguntas, { PerguntaFrequente } from "./ListaPerguntas";

const FAQ_ITEMS: PerguntaFrequente[] = [
    {
        pergunta: "O que é o Logigate?",
        resposta:
            "O Logigate é um software de gestão empresarial (ERP) que oferece soluções integradas para diversas áreas de uma empresa, como Facturação, Recursos Humanos, Finanças, Gestão Hospitalar, Gestão de Hotelaria e muito mais.",
    },
    {
        pergunta: "Quais são os preços do Logigate?",
        resposta:
            "Os preços dependem do que escolher: um combo (vários módulos a um preço só, mais barato do que em separado) ou módulo a módulo, cada um com planos adequados ao tamanho da empresa. Todos os preços mostrados são mensais e já incluem IVA.",
    },
    {
        pergunta: "O que é um combo?",
        resposta:
            "Um combo junta vários módulos, cada um no seu plano, a um preço único. Por exemplo, Facturação, Gestão Hospitalar e Recursos Humanos para uma clínica. Podes ver os combos disponíveis na secção de Planos.",
    },
    {
        pergunta: "Alguns módulos dependem de outros?",
        resposta:
            "Sim. A Gestão Hospitalar e a Humbi Shop, por exemplo, emitem facturas e por isso precisam do módulo de Facturação, que é incluído automaticamente quando os escolhe.",
    },
    {
        pergunta: "Posso experimentar gratuitamente?",
        resposta:
            "Sim! Alguns módulos como a Avaliação de Desempenho são totalmente gratuitos, e as escolas da Escola Inteligente têm a Facturação incluída sem custo. Para os restantes módulos, podes criar a tua empresa e experimentar as funcionalidades disponíveis.",
    },
    {
        pergunta: "Posso mudar de plano depois?",
        resposta:
            "Sim, a qualquer momento, no painel da empresa. Subir de plano entra em vigor de imediato: os módulos novos ficam disponíveis logo, tem 7 dias para pagar e os dias que ainda não tinha usado do plano anterior são convertidos em dias no fim do plano novo. Descer de plano fica agendado e entra em vigor no fim do período actual, com a renovação.",
    },
    {
        pergunta: "Como funciona a cobrança e a renovação?",
        resposta:
            "Podes escolher períodos de 1, 3, 6, 12 ou 24 meses. Ao criar a empresa é gerada uma factura, a pagar em 7 dias. Sete dias antes do fim do período emitimos a factura da renovação; depois do fim há ainda 7 dias de tolerância antes de os módulos ficarem bloqueados. Podes desligar a renovação automática no painel.",
    },
    {
        pergunta: "O que é o Logigate para prestadores de serviços?",
        resposta:
            "É uma conta mais simples e mais barata para quem trabalha em nome individual e só precisa de facturar serviços: inclui a Facturação certificada pela AGT, a tesouraria (entradas e saídas) e as estatísticas. Não tem produtos, stock, encomendas nem vários estabelecimentos. Os planos começam em 1.000 Kz por mês, com IVA incluído.",
    },
    {
        pergunta: "Sou prestador e preciso de produtos ou de mais módulos. E agora?",
        resposta:
            "A conta de prestador é só para serviços. Se vendes produtos, tens armazém ou várias lojas, ou precisas de módulos como Recursos Humanos ou POS, cria uma conta de empresa: os planos para empresas estão na secção de Planos e Preços.",
    },
    {
        pergunta: "O Logigate é personalizável?",
        resposta:
            "Sim, o Logigate é altamente personalizável. Cada empresa pode configurar os seus módulos, permissões de utilizadores, templates de documentos e muito mais de acordo com as suas necessidades específicas.",
    },
    {
        pergunta: "Como posso obter suporte?",
        resposta: "O Logigate oferece suporte contínuo. Pode entrar em contacto através da nossa página de contactos em hongayetu.com/contactos ou ligar para +244 948 242 262.",
    },
];

export default function FAQSection() {
    return (
        <section id="faq" className="py-20 lg:py-28 bg-gray-50">
            <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
                <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5 }} className="text-center mb-12">
                    <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">Perguntas Frequentes</h2>
                    <p className="text-lg text-gray-500">Tudo o que precisas de saber sobre o Logigate.</p>
                </motion.div>

                <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5, delay: 0.1 }}>
                    <ListaPerguntas perguntas={FAQ_ITEMS} prefixo="faq" />
                </motion.div>
            </div>
        </section>
    );
}
